import { render } from "./BaseLoader.vue?vue&type=template&id=48ce30bc&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=48ce30bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ce30bc"]])

export default __exports__